import React, { useEffect, useState, useContext } from 'react';
import { UserContext } from '../../contexts/UserContext';
import { getPageContainerStyles } from '../../utils/styleUtils';
import { hasAdminAccess } from '../../utils/permissionConfig';
import { api } from '../../services/api';

// 다국어 텍스트
const TEXT = {
  // 서브메뉴 탭
  tabs: {
    main: {
      ko: '관리 메인페이지',
      en: 'Admin Main',
      fr: 'Page principale'
    },
    create: {
      ko: '게스트 계정 만들기',
      en: 'Create Guest Account',
      fr: 'Créer un compte invité'
    },
    manage: {
      ko: '게스트 계정 관리',
      en: 'Manage Guest Accounts',
      fr: 'Gérer les comptes invités'
    }
  },
  // 메인 페이지
  renewal: {
    ko: '리뉴얼중입니다',
    en: 'Under Renewal',
    fr: 'En cours de renouvellement'
  },
  // 기존 텍스트
  title: {
    ko: '게스트 아티스트 관리',
    en: 'Guest Artists Management',
    fr: 'Gestion des artistes invités'
  },
  loading: {
    ko: '로딩 중...',
    en: 'Loading...',
    fr: 'Chargement...'
  },
  noArtists: {
    ko: '게스트 아티스트가 없습니다.',
    en: 'No guest artists found.',
    fr: 'Aucun artiste invité trouvé.'
  },
  deleteConfirm: {
    ko: '이 게스트 계정을 완전히 삭제하시겠습니까?',
    en: 'Are you sure you want to permanently delete this guest account?',
    fr: 'Êtes-vous sûr de vouloir supprimer définitivement ce compte invité ?'
  },
  delete: {
    ko: '삭제',
    en: 'Delete',
    fr: 'Supprimer'
  },
  headers: {
    userId: { ko: 'ID', en: 'ID', fr: 'ID' },
    loginId: { ko: '로그인', en: 'Login', fr: 'Connexion' },
    userName: { ko: '이름', en: 'Name', fr: 'Nom' },
    email: { ko: '이메일', en: 'Email', fr: 'Email' },
    joinedAt: { ko: '가입일', en: 'Joined', fr: 'Inscription' },
    status: { ko: '상태', en: 'Status', fr: 'Statut' },
    location: { ko: '위치', en: 'Location', fr: 'Lieu' },
    level: { ko: '레벨', en: 'Level', fr: 'Niveau' },
    color: { ko: '색상', en: 'Color', fr: 'Couleur' },
    guestPeriod: { ko: '게스트 기간', en: 'Guest Period', fr: 'Période invité' },
    guestStart: { ko: '시작', en: 'Start', fr: 'Début' },
    guestEnd: { ko: '종료', en: 'End', fr: 'Fin' },
    commission: { ko: '커미션', en: 'Commission', fr: 'Commission' },
    commissionLimit: { ko: '한도', en: 'Limit', fr: 'Limite' }
  },
  // 게스트 등록 폼 텍스트
  registration: {
    title: { ko: '게스트 아티스트 등록', en: 'Guest Artist Registration', fr: "Inscription d'artiste invité" },
    subtitle: { ko: '새로운 게스트 아티스트를 등록합니다.', en: 'Register a new guest artist.', fr: 'Inscrire un nouvel artiste invité.' },
    userInfo: { ko: '사용자 정보', en: 'User Information', fr: 'Informations utilisateur' },
    guestProfile: { ko: '게스트 프로필 정보', en: 'Guest Profile Information', fr: "Informations du profil d'invité" },
    loginId: { ko: '로그인 아이디 *', en: 'Login ID *', fr: 'ID de connexion *' },
    name: { ko: '이름 *', en: 'Name *', fr: 'Nom *' },
    email: { ko: '이메일', en: 'Email', fr: 'Email' },
    tempPassword: { ko: '임시 비밀번호 *', en: 'Temporary Password *', fr: 'Mot de passe temporaire *' },
    color: { ko: '색상', en: 'Color', fr: 'Couleur' },
    language: { ko: '선호 언어 *', en: 'Preferred Language *', fr: 'Langue préférée *' },
    instagram: { ko: '인스타그램 ID', en: 'Instagram ID', fr: 'ID Instagram' },
    startDate: { ko: '게스트 시작일 *', en: 'Guest Start Date *', fr: 'Date de début *' },
    endDate: { ko: '게스트 종료일 *', en: 'Guest End Date *', fr: 'Date de fin *' },
    commission: { ko: '커미션 퍼센테이지 (%)', en: 'Commission Percentage (%)', fr: 'Pourcentage de commission (%)' },
    commissionLimit: { ko: '커미션 제한 금액', en: 'Commission Limit Amount', fr: 'Montant limite de commission' },
    visits: { ko: '총 게스트 방문수', en: 'Total Guest Visits', fr: 'Nombre total de visites' },
    active: { ko: '계정 활성화', en: 'Account Active', fr: 'Compte actif' },
    submit: { ko: '게스트 아티스트 등록', en: 'Register Guest Artist', fr: "Inscrire l'artiste invité" },
    submitting: { ko: '등록 중...', en: 'Registering...', fr: 'Inscription...' },
    cancel: { ko: '취소', en: 'Cancel', fr: 'Annuler' }
  },
  // 게스트에게 전달할 계정 안내 메시지 (게스트 언어 기준)
  credentialMessage: {
    ko: (loginId, password) =>
`< GNEGNEGNE 게스트 캘린더 계정 >

아이디 : ${loginId}
비밀번호 : ${password}

< 접속방법 >

1. 컴퓨터,모바일 등 모든 환경에서 접속가능
2. 주소 : http://gnegnegne.fr
3. 접속하면 해당 페이지의 우측하단에 점들로 이루어진 애니메이션이 있음. 그거를 클릭 두번 하면 로그인페이지로 이동.
4. 모바일의경우, 접속후 해당 페이지를 휴대폰 어플화면에 추가해서 어플처럼 사용가능. ( 보통 모바일 웹브라우저에서, 공유하기 같은 버튼 내부에 '휴대폰 메인화면에 추가' 같은 식의 버튼으로 가능 )
5. 그 이후에 위의 아이디와 비밀번호로 로그인하면 됨.
6. 그 외 문의사항있으면 연락주세요!`,
    en: (loginId, password) =>
`< GNEGNEGNE Guest Calendar Account >

ID : ${loginId}
Password : ${password}

< How to Access >

1. Accessible from all devices — computer, mobile, etc.
2. URL : http://gnegnegne.fr
3. Once on the page, you'll see a dot animation in the bottom-right corner. Double-click it to go to the login page.
4. On mobile, after accessing the page, you can add it to your home screen to use it like an app. (Usually found under the "Share" button in your mobile browser, look for "Add to Home Screen")
5. Then simply log in with the ID and password above.
6. If you have any questions, feel free to contact us!`,
    fr: (loginId, password) =>
`< Compte Calendrier Invité GNEGNEGNE >

Identifiant : ${loginId}
Mot de passe : ${password}

< Comment accéder >

1. Accessible depuis tous les appareils — ordinateur, mobile, etc.
2. Adresse : http://gnegnegne.fr
3. Une fois sur la page, vous verrez une animation de points en bas à droite. Double-cliquez dessus pour accéder à la page de connexion.
4. Sur mobile, après avoir accédé à la page, vous pouvez l'ajouter à votre écran d'accueil pour l'utiliser comme une application. (En général, dans le navigateur mobile, via le bouton "Partager" puis "Ajouter à l'écran d'accueil")
5. Ensuite, connectez-vous avec l'identifiant et le mot de passe ci-dessus.
6. Pour toute question, n'hésitez pas à nous contacter !`
  },
  copyButton: { ko: '복사', en: 'Copy', fr: 'Copier' },
  copiedButton: { ko: '복사됨 ✓', en: 'Copied ✓', fr: 'Copié ✓' }
};

// 서브메뉴 헤더 스타일
const submenuStyles = {
  container: {
    display: 'flex',
    gap: '0',
    borderBottom: '2px solid #333',
    marginBottom: '20px',
    backgroundColor: '#f8f8f8'
  },
  tab: {
    padding: '12px 24px',
    cursor: 'pointer',
    border: 'none',
    backgroundColor: 'transparent',
    fontSize: '14px',
    fontWeight: '500',
    color: '#666',
    transition: 'all 0.2s ease',
    borderBottom: '3px solid transparent',
    marginBottom: '-2px'
  },
  activeTab: {
    color: '#000',
    fontWeight: '700',
    borderBottom: '3px solid #000',
    backgroundColor: '#fff'
  }
};

const GUEST_LIST_LIMIT = 1000;

const getApiErrorMessage = (error, fallbackMessage) =>
  error?.data?.error?.message || error?.data?.message || error?.message || fallbackMessage;

const sortDateStrings = (dates = []) => [...dates].sort((left, right) => left.localeCompare(right));

const isDateWithinRange = (date, startDate, endDate) => {
  if (!date) return false;
  if (startDate && date < startDate) return false;
  if (endDate && date > endDate) return false;
  return true;
};

const normalizeGuestArtist = (guest) => ({
  ...guest,
  guest_profile_id: guest?.guest_profile_id ?? guest?.id ?? null
});

const GuestArtists = () => {
  const { userInfo } = useContext(UserContext);
  const [activeTab, setActiveTab] = useState('main'); // 'main', 'create', 'manage'
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const lang = userInfo?.preferred_language || 'ko';

  // 게스트 등록 폼 상태
  const [formData, setFormData] = useState({
    user_login_id: '',
    user_name: '',
    email: '',
    temp_password: '',
    color: '#cccccc',
    preferred_language: 'ko',
    instagram_id: '',
    guest_start_date: '',
    guest_end_date: '',
    commission_percentage: 0.00,
    commission_limit_amount: '',
    is_active: true,
    total_guest_visits: 0
  });
  const [formErrors, setFormErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [copied, setCopied] = useState(false);
  const [guestDayOffs, setGuestDayOffs] = useState({});
  const [guestDayOffInputs, setGuestDayOffInputs] = useState({});

  // 공통 스타일
  const pageContainerStyles = getPageContainerStyles();

  const loadGuestDayOffsForUser = async (userId, startDate, endDate) => {
    if (!userId || !startDate || !endDate) {
      return [];
    }

    try {
      const data = await api.get('/artist-dayoff', {
        artist_id: userId,
        start: startDate,
        end: endDate
      });

      return sortDateStrings(
        (Array.isArray(data) ? data : [])
          .map((entry) => entry?.day)
          .filter(Boolean)
      );
    } catch (loadError) {
      console.error(`Failed to load blocked days for guest user ${userId}:`, loadError);
      return [];
    }
  };

  // 게스트 아티스트 목록 로드
  useEffect(() => {
    if (hasAdminAccess(userInfo) && activeTab === 'manage') {
      setLoading(true);
      api.get('/guest-artists', { limit: GUEST_LIST_LIMIT })
        .then(async (data) => {
          const guestArtists = Array.isArray(data?.data?.guests) ? data.data.guests : [];
          const normalizedGuestArtists = guestArtists.map(normalizeGuestArtist);
          setArtists(normalizedGuestArtists);
          setGuestDayOffInputs(
            Object.fromEntries(normalizedGuestArtists.map((guest) => [guest.user_id, '']))
          );

          const blockedDayEntries = await Promise.all(
            normalizedGuestArtists.map(async (guest) => [
              guest.user_id,
              await loadGuestDayOffsForUser(
                guest.user_id,
                guest.guest_start_date,
                guest.guest_end_date
              )
            ])
          );
          setGuestDayOffs(Object.fromEntries(blockedDayEntries));
          setError(null);
        })
        .catch((err) => {
          console.error('Load error:', err);
          setError(getApiErrorMessage(err, 'Failed to load guest artists.'));
          setGuestDayOffs({});
          setGuestDayOffInputs({});
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [userInfo, activeTab]);

  // 게스트 아티스트 편집 (일반)
  const handleEdit = async (userId, key, value) => {
    setLoading(true);
    try {
      await api.put(`/admin/users/${userId}`, { [key]: value });

      setArtists((prev) =>
        prev.map((u) => u.user_id === userId ? { ...u, [key]: value } : u)
      );
      setError(null);
    } catch (err) {
      console.error('Edit error:', err);
      setError(getApiErrorMessage(err, 'Failed to update guest artist.'));
    } finally {
      setLoading(false);
    }
  };

  // 게스트 기간 업데이트
  const handleUpdateGuestPeriod = async (guestProfileId, userId, startDate, endDate) => {
    if (!guestProfileId) {
      setError('게스트 프로필 정보를 찾을 수 없습니다.');
      return;
    }

    setLoading(true);
    try {
      await api.put(`/guest-artists/${guestProfileId}`, {
        guest_start_date: startDate,
        guest_end_date: endDate
      });

      setArtists((prev) =>
        prev.map((u) => (
          u.user_id === userId
            ? { ...u, guest_start_date: startDate, guest_end_date: endDate }
            : u
        ))
      );
      const refreshedBlockedDays = await loadGuestDayOffsForUser(userId, startDate, endDate);
      setGuestDayOffs((prev) => ({
        ...prev,
        [userId]: refreshedBlockedDays
      }));
      setGuestDayOffInputs((prev) => ({
        ...prev,
        [userId]: isDateWithinRange(prev[userId], startDate, endDate) ? prev[userId] : ''
      }));
      setError(null);
      alert('게스트 기간이 수정되었습니다.');
    } catch (err) {
      console.error('Update period error:', err);
      setError(getApiErrorMessage(err, 'Failed to update guest period.'));
      alert('게스트 기간 수정에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleBlockedDayInputChange = (userId, value) => {
    setGuestDayOffInputs((prev) => ({
      ...prev,
      [userId]: value
    }));
  };

  const handleAddBlockedDay = async (userId, startDate, endDate) => {
    const day = guestDayOffInputs[userId];

    if (!day) {
      setError('추가할 금지일을 선택해주세요.');
      return;
    }

    if (!isDateWithinRange(day, startDate, endDate)) {
      setError('금지일은 게스트 기간 안에서만 지정할 수 있습니다.');
      return;
    }

    setLoading(true);
    try {
      await api.post('/artist-dayoff', {
        artist_id: userId,
        day,
        status: 'DayOff'
      });

      setGuestDayOffs((prev) => ({
        ...prev,
        [userId]: sortDateStrings([...(prev[userId] || []), day])
          .filter((value, index, source) => source.indexOf(value) === index)
      }));
      setGuestDayOffInputs((prev) => ({
        ...prev,
        [userId]: ''
      }));
      setError(null);
    } catch (err) {
      console.error('Blocked day add error:', err);
      setError(getApiErrorMessage(err, '금지일 추가에 실패했습니다.'));
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveBlockedDay = async (userId, day) => {
    setLoading(true);
    try {
      await api.delete(`/artist-dayoff?artist_id=${userId}&day=${encodeURIComponent(day)}`);
      setGuestDayOffs((prev) => ({
        ...prev,
        [userId]: (prev[userId] || []).filter((value) => value !== day)
      }));
      setError(null);
    } catch (err) {
      console.error('Blocked day remove error:', err);
      setError(getApiErrorMessage(err, '금지일 삭제에 실패했습니다.'));
    } finally {
      setLoading(false);
    }
  };

  // 게스트 아티스트 삭제
  const handleDelete = async (userId) => {
    if (!window.confirm(TEXT.deleteConfirm[lang])) return;
    setLoading(true);

    try {
      const result = await api.delete(`/admin/users/${userId}`);
      console.log('Delete response:', result);

      setArtists((prev) => prev.filter((u) => u.user_id !== userId));
      setError(null);
    } catch (err) {
      console.error('Delete error:', err);
      const errorMessage = getApiErrorMessage(err, 'Failed to delete guest artist.');
      setError(errorMessage);
      alert(`삭제 실패: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  };

  // 폼 입력 핸들러
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    if (formErrors[name]) {
      setFormErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  // 폼 검증
  const validateField = (name, value) => {
    switch (name) {
      case 'user_login_id':
        if (!value) return '로그인 아이디는 필수입니다.';
        if (value.length < 3) return '로그인 아이디는 최소 3자 이상이어야 합니다.';
        if (!/^[a-zA-Z0-9_]+$/.test(value)) return '로그인 아이디는 영문, 숫자, 언더스코어만 사용 가능합니다.';
        break;
      case 'user_name':
        if (!value) return '이름은 필수입니다.';
        break;
      case 'temp_password':
        if (!value) return '임시 비밀번호는 필수입니다.';
        if (value.length < 8) return '비밀번호는 최소 8자 이상이어야 합니다.';
        break;
      case 'email':
        if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          return '올바른 이메일 형식이 아닙니다.';
        }
        break;
      case 'guest_start_date':
        if (!value) return '게스트 시작일은 필수입니다.';
        break;
      case 'guest_end_date':
        if (!value) return '게스트 종료일은 필수입니다.';
        if (formData.guest_start_date && value < formData.guest_start_date) {
          return '게스트 종료일은 시작일 이전일 수 없습니다.';
        }
        break;
      default:
        break;
    }
    return '';
  };

  // 폼 제출
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMessage('');
    setErrorMessage('');

    const newErrors = {};
    Object.keys(formData).forEach(key => {
      const error = validateField(key, formData[key]);
      if (error) newErrors[key] = error;
    });

    if (Object.keys(newErrors).length > 0) {
      setFormErrors(newErrors);
      setLoading(false);
      return;
    }

    try {
      await api.post('/guest-artists/register', formData);

      // 게스트의 선호 언어로 안내 메시지 생성
      const guestLang = formData.preferred_language || 'ko';
      const credentialMsg = TEXT.credentialMessage[guestLang](formData.user_login_id, formData.temp_password);

      setSuccessMessage(credentialMsg);
      setCopied(false);

      // 폼 초기화
      setFormData({
        user_login_id: '',
        user_name: '',
        email: '',
        temp_password: '',
        color: '#cccccc',
        preferred_language: 'ko',
        instagram_id: '',
        guest_start_date: '',
        guest_end_date: '',
        commission_percentage: 0.00,
        commission_limit_amount: '',
        is_active: true,
        total_guest_visits: 0
      });
      setFormErrors({});

    } catch (error) {
      setErrorMessage(getApiErrorMessage(error, '게스트 아티스트 등록에 실패했습니다.'));
    } finally {
      setLoading(false);
    }
  };

  // 메인 페이지 렌더링
  const renderMainPage = () => (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '300px',
      fontSize: '24px',
      fontWeight: '600',
      color: '#666'
    }}>
      {TEXT.renewal[lang]}
    </div>
  );

  // 게스트 계정 만들기 폼 렌더링
  const renderCreateForm = () => (
    <div style={{ padding: '20px 0' }}>
      <div style={{ marginBottom: '20px' }}>
        <h2 style={{ margin: '0 0 8px 0', fontSize: '20px' }}>{TEXT.registration.title[lang]}</h2>
        <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>{TEXT.registration.subtitle[lang]}</p>
      </div>

      {successMessage && (
        <div style={{
          padding: '16px',
          backgroundColor: '#d4edda',
          border: '1px solid #c3e6cb',
          borderRadius: '8px',
          marginBottom: '20px',
          position: 'relative'
        }}>
          <pre style={{
            margin: 0,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            fontFamily: 'inherit',
            fontSize: '13px',
            lineHeight: '1.6'
          }}>{successMessage}</pre>
          <button
            onClick={() => {
              navigator.clipboard.writeText(successMessage).then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
              });
            }}
            style={{
              marginTop: '12px',
              padding: '8px 20px',
              backgroundColor: copied ? '#28a745' : '#000',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              fontSize: '13px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease'
            }}
          >
            {copied ? TEXT.copiedButton[lang] : TEXT.copyButton[lang]}
          </button>
        </div>
      )}

      {errorMessage && (
        <div style={{
          padding: '16px',
          backgroundColor: '#f8d7da',
          border: '1px solid #f5c6cb',
          borderRadius: '4px',
          marginBottom: '20px'
        }}>
          {errorMessage}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        {/* 사용자 정보 섹션 */}
        <div style={{ marginBottom: '24px' }}>
          <h3 style={{ fontSize: '16px', marginBottom: '16px', borderBottom: '1px solid #ddd', paddingBottom: '8px' }}>
            {TEXT.registration.userInfo[lang]}
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
                {TEXT.registration.loginId[lang]}
              </label>
              <input
                type="text"
                name="user_login_id"
                value={formData.user_login_id}
                onChange={handleInputChange}
                style={{ width: '100%', padding: '8px', border: formErrors.user_login_id ? '1px solid red' : '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' }}
                placeholder="예: guest_artist_1"
              />
              {formErrors.user_login_id && <span style={{ color: 'red', fontSize: '12px' }}>{formErrors.user_login_id}</span>}
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
                {TEXT.registration.name[lang]}
              </label>
              <input
                type="text"
                name="user_name"
                value={formData.user_name}
                onChange={handleInputChange}
                style={{ width: '100%', padding: '8px', border: formErrors.user_name ? '1px solid red' : '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' }}
              />
              {formErrors.user_name && <span style={{ color: 'red', fontSize: '12px' }}>{formErrors.user_name}</span>}
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
                {TEXT.registration.email[lang]}
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                style={{ width: '100%', padding: '8px', border: formErrors.email ? '1px solid red' : '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' }}
              />
              {formErrors.email && <span style={{ color: 'red', fontSize: '12px' }}>{formErrors.email}</span>}
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
                {TEXT.registration.tempPassword[lang]}
              </label>
              <input
                type="password"
                name="temp_password"
                value={formData.temp_password}
                onChange={handleInputChange}
                style={{ width: '100%', padding: '8px', border: formErrors.temp_password ? '1px solid red' : '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' }}
                placeholder="최소 8자 이상"
              />
              {formErrors.temp_password && <span style={{ color: 'red', fontSize: '12px' }}>{formErrors.temp_password}</span>}
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
                {TEXT.registration.color[lang]}
              </label>
              <input
                type="color"
                name="color"
                value={formData.color}
                onChange={handleInputChange}
                style={{ width: '60px', height: '36px', padding: '2px', border: '1px solid #ccc', borderRadius: '4px' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
                {TEXT.registration.language[lang]}
              </label>
              <select
                name="preferred_language"
                value={formData.preferred_language}
                onChange={handleInputChange}
                style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' }}
              >
                <option value="ko">한국어</option>
                <option value="en">English</option>
                <option value="fr">Français</option>
              </select>
            </div>
          </div>
        </div>

        {/* 게스트 프로필 섹션 */}
        <div style={{ marginBottom: '24px' }}>
          <h3 style={{ fontSize: '16px', marginBottom: '16px', borderBottom: '1px solid #ddd', paddingBottom: '8px' }}>
            {TEXT.registration.guestProfile[lang]}
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
                {TEXT.registration.instagram[lang]}
              </label>
              <input
                type="text"
                name="instagram_id"
                value={formData.instagram_id}
                onChange={handleInputChange}
                style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' }}
                placeholder="@instagram_id"
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
                {TEXT.registration.startDate[lang]}
              </label>
              <input
                type="date"
                name="guest_start_date"
                value={formData.guest_start_date}
                onChange={handleInputChange}
                style={{ width: '100%', padding: '8px', border: formErrors.guest_start_date ? '1px solid red' : '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' }}
              />
              {formErrors.guest_start_date && <span style={{ color: 'red', fontSize: '12px' }}>{formErrors.guest_start_date}</span>}
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
                {TEXT.registration.endDate[lang]}
              </label>
              <input
                type="date"
                name="guest_end_date"
                value={formData.guest_end_date}
                onChange={handleInputChange}
                style={{ width: '100%', padding: '8px', border: formErrors.guest_end_date ? '1px solid red' : '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' }}
              />
              {formErrors.guest_end_date && <span style={{ color: 'red', fontSize: '12px' }}>{formErrors.guest_end_date}</span>}
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
                {TEXT.registration.commission[lang]}
              </label>
              <input
                type="number"
                name="commission_percentage"
                value={formData.commission_percentage}
                onChange={handleInputChange}
                min="0"
                max="100"
                step="0.01"
                style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
                {TEXT.registration.commissionLimit[lang]}
              </label>
              <input
                type="number"
                name="commission_limit_amount"
                value={formData.commission_limit_amount}
                onChange={handleInputChange}
                min="0"
                style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
                {TEXT.registration.visits[lang]}
              </label>
              <input
                type="number"
                name="total_guest_visits"
                value={formData.total_guest_visits}
                onChange={handleInputChange}
                min="0"
                style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box' }}
              />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', paddingTop: '24px' }}>
              <input
                type="checkbox"
                name="is_active"
                checked={formData.is_active}
                onChange={handleInputChange}
                style={{ width: '18px', height: '18px' }}
              />
              <label style={{ fontWeight: '500', fontSize: '14px' }}>
                {TEXT.registration.active[lang]}
              </label>
            </div>
          </div>
        </div>

        {/* 버튼 영역 */}
        <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
          <button
            type="submit"
            disabled={loading}
            style={{
              padding: '12px 24px',
              backgroundColor: '#000',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1
            }}
          >
            {loading ? TEXT.registration.submitting[lang] : TEXT.registration.submit[lang]}
          </button>
        </div>
      </form>
    </div>
  );

  // 날짜 포맷 헬퍼
  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleDateString('ko-KR', { month: 'short', day: 'numeric' });
  };

  // 게스트 계정 관리 카드 렌더링 (컴팩트)
  const renderManageCards = () => (
    <div style={{ paddingTop: '12px' }}>
      {loading && <p style={{ margin: '0 0 10px 0', fontSize: '13px' }}>{TEXT.loading[lang]}</p>}
      {error && <p style={{ color: 'red', margin: '0 0 10px 0', fontSize: '13px' }}>{error}</p>}

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: '12px'
      }}>
        {Array.isArray(artists) && artists.map((u) => (
          <div
            key={u.user_id}
            style={{
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              padding: '12px',
              backgroundColor: '#fff',
              borderLeft: `3px solid ${u.color || '#ccc'}`
            }}
          >
            {/* 헤더: 이름 + 색상 + 삭제 */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', paddingBottom: '8px', borderBottom: '1px solid #eee' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type="color"
                  value={u.color || '#cccccc'}
                  onChange={(e) => handleEdit(u.user_id, 'color', e.target.value)}
                  disabled={loading}
                  aria-label={`${u.user_name || u.user_login_id} color`}
                  style={{ width: '24px', height: '24px', padding: 0, border: '1px solid #ddd', borderRadius: '50%', backgroundColor: 'transparent', cursor: 'pointer' }}
                />
                <div>
                  <div style={{ fontWeight: '600', fontSize: '14px' }}>{u.user_name || 'Unknown'}</div>
                  <div style={{ fontSize: '11px', color: '#888' }}>@{u.user_login_id}</div>
                </div>
              </div>
              <button
                onClick={() => handleDelete(u.user_id)}
                disabled={loading}
                style={{ padding: '4px 8px', fontSize: '11px', backgroundColor: '#fff', color: '#d32f2f', border: '1px solid #d32f2f', borderRadius: '4px', cursor: 'pointer' }}
              >
                {TEXT.delete[lang]}
              </button>
            </div>

            {/* 기본 정보 */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 12px', marginBottom: '8px', fontSize: '12px' }}>
              <div style={{ display: 'flex', gap: '4px' }}>
                <span style={{ color: '#888' }}>{TEXT.headers.email[lang]}</span>
                <span style={{ fontWeight: '500' }}>{u.email || '-'}</span>
              </div>
              <div style={{ display: 'flex', gap: '4px' }}>
                <span style={{ color: '#888' }}>{TEXT.headers.status[lang]}</span>
                <span style={{ fontWeight: '500' }}>{u.status || '-'}</span>
              </div>
              <div style={{ display: 'flex', gap: '4px' }}>
                <span style={{ color: '#888' }}>{TEXT.headers.location[lang]}</span>
                <span style={{ fontWeight: '500' }}>{u.location || '-'}</span>
              </div>
              <div style={{ display: 'flex', gap: '4px' }}>
                <span style={{ color: '#888' }}>{TEXT.headers.joinedAt[lang]}</span>
                <span style={{ fontWeight: '500' }}>{formatDate(u.joined_at)}</span>
              </div>
            </div>

            {/* 게스트 기간 & 커미션 */}
            <div style={{ backgroundColor: '#f8f8f8', borderRadius: '4px', padding: '8px', fontSize: '11px' }}>
              <div style={{ marginBottom: '8px' }}>
                <span style={{ color: '#666', display: 'block', marginBottom: '4px' }}>{TEXT.headers.guestPeriod[lang]}</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
                  <input
                    type="date"
                    defaultValue={u.guest_start_date ? u.guest_start_date.split('T')[0] : ''}
                    id={`start-${u.user_id}`}
                    style={{ padding: '4px', fontSize: '11px', border: '1px solid #ccc', borderRadius: '4px' }}
                  />
                  <span>~</span>
                  <input
                    type="date"
                    defaultValue={u.guest_end_date ? u.guest_end_date.split('T')[0] : ''}
                    id={`end-${u.user_id}`}
                    style={{ padding: '4px', fontSize: '11px', border: '1px solid #ccc', borderRadius: '4px' }}
                  />
                  <button
                    onClick={() => {
                      const startInput = document.getElementById(`start-${u.user_id}`);
                      const endInput = document.getElementById(`end-${u.user_id}`);
                      if (startInput.value && endInput.value) {
                        handleUpdateGuestPeriod(
                          u.guest_profile_id,
                          u.user_id,
                          startInput.value,
                          endInput.value
                        );
                      }
                    }}
                    disabled={loading}
                    style={{ padding: '4px 8px', fontSize: '10px', backgroundColor: '#000', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                  >
                    저장
                  </button>
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: '#666' }}>{TEXT.headers.commission[lang]}</span>
                <span style={{ fontWeight: '500' }}>
                  {u.commission_percentage != null ? `${u.commission_percentage}%` : '-'}
                  {u.commission_limit_amount ? ` (${TEXT.headers.commissionLimit[lang]}: ${u.commission_limit_amount}€)` : ''}
                </span>
              </div>

              <div style={{ marginTop: '10px', paddingTop: '8px', borderTop: '1px solid #e6e6e6' }}>
                <span style={{ color: '#666', display: 'block', marginBottom: '6px' }}>금지일</span>
                <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap', marginBottom: '6px' }}>
                  <input
                    type="date"
                    value={guestDayOffInputs[u.user_id] || ''}
                    min={u.guest_start_date ? u.guest_start_date.split('T')[0] : undefined}
                    max={u.guest_end_date ? u.guest_end_date.split('T')[0] : undefined}
                    onChange={(event) => handleBlockedDayInputChange(u.user_id, event.target.value)}
                    style={{ padding: '4px', fontSize: '11px', border: '1px solid #ccc', borderRadius: '4px' }}
                  />
                  <button
                    type="button"
                    onClick={() => handleAddBlockedDay(
                      u.user_id,
                      u.guest_start_date ? u.guest_start_date.split('T')[0] : '',
                      u.guest_end_date ? u.guest_end_date.split('T')[0] : ''
                    )}
                    disabled={loading}
                    style={{ padding: '4px 8px', fontSize: '10px', backgroundColor: '#222', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                  >
                    추가
                  </button>
                </div>

                {(guestDayOffs[u.user_id] || []).length > 0 ? (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                    {(guestDayOffs[u.user_id] || []).map((day) => (
                      <span
                        key={`${u.user_id}-${day}`}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '4px',
                          padding: '3px 6px',
                          backgroundColor: '#ececec',
                          borderRadius: '999px',
                          color: '#444'
                        }}
                      >
                        <span>{formatDate(day)}</span>
                        <button
                          type="button"
                          onClick={() => handleRemoveBlockedDay(u.user_id, day)}
                          disabled={loading}
                          aria-label={`remove blocked day ${day}`}
                          style={{
                            border: 'none',
                            backgroundColor: 'transparent',
                            color: '#777',
                            cursor: 'pointer',
                            padding: 0,
                            lineHeight: 1
                          }}
                        >
                          ×
                        </button>
                      </span>
                    ))}
                  </div>
                ) : (
                  <div style={{ color: '#999' }}>지정된 금지일 없음</div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {artists.length === 0 && !loading && (
        <div style={{ textAlign: 'center', padding: '40px 20px', color: '#666', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
          {TEXT.noArtists[lang]}
        </div>
      )}
    </div>
  );

  return (
    <div className={pageContainerStyles.pageContainer} style={{
      height: '100%',
      overflow: 'auto',
      paddingBottom: '100px',
      boxSizing: 'border-box'
    }}>
      {/* 페이지 타이틀 */}
      <h1 className={pageContainerStyles.pageTitle}>
        {TEXT.title[lang]}
      </h1>

      {/* 서브메뉴 헤더 */}
      <div style={submenuStyles.container}>
        <button
          style={{
            ...submenuStyles.tab,
            ...(activeTab === 'main' ? submenuStyles.activeTab : {})
          }}
          onClick={() => setActiveTab('main')}
        >
          {TEXT.tabs.main[lang]}
        </button>
        <button
          style={{
            ...submenuStyles.tab,
            ...(activeTab === 'create' ? submenuStyles.activeTab : {})
          }}
          onClick={() => setActiveTab('create')}
        >
          {TEXT.tabs.create[lang]}
        </button>
        <button
          style={{
            ...submenuStyles.tab,
            ...(activeTab === 'manage' ? submenuStyles.activeTab : {})
          }}
          onClick={() => setActiveTab('manage')}
        >
          {TEXT.tabs.manage[lang]}
        </button>
      </div>

      {/* 콘텐츠 영역 */}
      {activeTab === 'main' && renderMainPage()}
      {activeTab === 'create' && renderCreateForm()}
      {activeTab === 'manage' && renderManageCards()}
    </div>
  );
};

export default GuestArtists;
